<ui-section>
  <ui-block>
    <ui-panel
      width="fill"
      class="platform-access-admin"
      panelTitle="Scopes"
      title="Scopes"
      [subtitle]="pagePanelSubtitle"
    >
      <div class="message-box success" *ngIf="successMessage()" role="status" aria-live="polite">
        {{ successMessage() }}
      </div>

      <div class="message-box error" *ngIf="errorState() as error" role="alert" aria-live="assertive">
        <p>{{ error.title }}</p>
        <ul>
          <li *ngFor="let message of error.messages">{{ message }}</li>
        </ul>
      </div>

      <div class="catalog-management-grid">
        <ui-panel width="fill" panelTitle="Scope Types" title="Scope Types">
          <ui-grid
            width="fill"
            class="catalog-panel"
            [dsConfig]="scopeTypeGridConfig"
            [panelHeaderConfig]="scopeTypePanelHeaderConfig"
            [showPanelHeader]="true"
          ></ui-grid>
        </ui-panel>

        <article class="detail-card">
          <div class="detail-card__header">
            <div>
              <h4>Add Scope Value</h4>
              <p>Define selectable values for non-global scope types.</p>
            </div>
          </div>

          <ui-form
            #scopeValueForm
            [config]="scopeValueFormConfig"
            [(formValues)]="scopeValueFormValues"
            [disabled]="isSaving()"
            [showFormErrors]="true"
          ></ui-form>

          <ui-button-group
            class="form-actions"
            [buttonsConfig]="formActionButtons()"
            (buttonClick)="onFormActionButtonClick($event)"
          ></ui-button-group>
        </article>
      </div>

      <ui-panel width="fill" panelTitle="Scope Values" title="Scope Values">
        <ui-grid
          width="fill"
          class="catalog-panel"
          [dsConfig]="scopeValueGridConfig"
          [panelHeaderConfig]="scopeValuePanelHeaderConfig"
          [showPanelHeader]="true"
          [reloadOnChangeTrigger]="scopeValuesReloadTrigger()"
        ></ui-grid>
      </ui-panel>
    </ui-panel>
  </ui-block>
</ui-section>
